import { Badge, Tooltip, TooltipContent, TooltipTrigger } from '@predoc/cow';
import { STATUS_CONFIG, ALL_PATIENT_STATUSES } from '../../constants';
import type { PatientStatus } from '../../types';

interface RequestStatusIconsProps {
  statusCounts: Partial<Record<PatientStatus, number>>;
}

/**
 * Reusable component to display a row of status icons with counts.
 * Used in patient list tables to show request status summary.
 */
export const RequestStatusIcons = ({
  statusCounts,
}: RequestStatusIconsProps) => {
  return (
    <div className="flex flex-nowrap items-center gap-0.5">
      {ALL_PATIENT_STATUSES.map((statusItem) => {
        const statusType = statusItem.type;
        const count = statusCounts[statusType] ?? 0;

        const statusConfig = STATUS_CONFIG[statusType];
        if (!statusConfig) return null;

        if (count <= 0) return null;

        const { icon: IconComponent, iconColor } = statusConfig;

        return (
          <div key={statusType}>
            <Tooltip>
              <TooltipTrigger asChild>
                <div>
                  <Badge
                    variant="inline"
                    className="flex h-full w-full items-center justify-center gap-1"
                    icon={<IconComponent className={`size-6 ${iconColor}`} />}
                  >
                    {count}
                  </Badge>
                </div>
              </TooltipTrigger>
              <TooltipContent side="bottom">{statusItem.label}</TooltipContent>
            </Tooltip>
          </div>
        );
      })}
    </div>
  );
};
